export default __webpack_public_path__ + "static/media/unsuccessful-call.9afd9530.svg";